import api from './api';

const extractData = (data) => (data && typeof data === 'object' && data.$values ? data.$values : data);

const financeService = {
  getDashboard: async () => {
    const { data } = await api.get('/finance/dashboard');
    return extractData(data);
  },

  listAppointments: async ({ startDate, endDate, professionalId, placeId }) => {
    const params = { startDate, endDate };
    if (professionalId) params.professionalId = professionalId;
    if (placeId) params.placeId = placeId;
    const { data } = await api.get('/finance/appointments', { params });
    return extractData(data);
  },

  getDetails: async (id) => {
    const { data } = await api.get(`/finance/appointments/${id}`);
    return extractData(data);
  },

  save: async (id, payload) => {
    const { data } = await api.put(`/finance/appointments/${id}`, payload);
    return extractData(data);
  },
};

export default financeService;
